
import { KolCategory, KolProfile, Order, OrderStatus, SocialPlatform, ProjectProfile, Notification, ChatConversation, UserRole, PaymentType, ViewState, Dispute, KolSquad } from './types';

export const MOCK_KOLS: KolProfile[] = [
  {
    id: '1',
    name: 'Crypto Wizard',
    handle: '@cryptowiz',
    avatar: 'https://picsum.photos/100/100?random=1',
    categories: [KolCategory.DEFI, KolCategory.L1_L2],
    tags: ['Ethereum', 'Layer2', 'ZK-Rollup', 'Audits'],
    totalFollowers: 155000,
    socialAccounts: [
      { platform: SocialPlatform.TWITTER, handle: '@cryptowiz', followers: 125000, url: '#', verified: true },
      { platform: SocialPlatform.YOUTUBE, handle: 'CryptoWizardTV', followers: 30000, url: '#', verified: true }
    ],
    engagementScore: 88,
    avgViews: 45000,
    priceRange: { min: 500, max: 2000, currency: 'USDT' },
    trustScore: 95,
    bio: 'Deep dives into L1 infrastructure and DeFi protocols. No memes, just tech.',
    languages: ['English', 'Spanish'],
    recentCampaigns: [
      { project: 'SuperNova', roi: 3.5 },
      { project: 'BaseLayer', roi: 2.1 }
    ],
    reviews: [
      { id: 'r1', reviewerName: 'SuperNova', rating: 5, comment: 'Excellent technical breakdown.', date: '2023-10-01', orderId: 'o1' }
    ],
    aiData: {
      overallScore: 92,
      authenticity: 95,
      sentiment: 88,
      commercialValue: 90,
      brandSafety: 98,
      consistency: 85,
      summary: 'High-trust technical KOL. Audience is primarily developers and investors.',
      strengths: ['Technical Depth', 'High Retention', 'Brand Safe'],
      weaknesses: ['Lower frequency', 'Niche audience']
    },
    packages: [
      { id: 'p1', title: 'Deep Dive Thread', description: 'A 10-tweet thread analyzing your protocol architecture.', platform: SocialPlatform.TWITTER, price: 800, deliveryDays: 3, features: ['Technical Analysis', 'Architectural Diagram', '24h Pin'] },
      { id: 'p2', title: 'YouTube Review', description: '10-minute dedicated video review.', platform: SocialPlatform.YOUTUBE, price: 1500, deliveryDays: 7, features: ['4K Quality', 'SEO Optimized', 'Links in bio'] }
    ],
    sbtBadges: [
        { id: 'b1', name: 'Verified OG', description: 'Platform member for >1 year', icon: 'ShieldCheck', dateEarned: '2022-11-15', rarity: 'Rare' },
        { id: 'b2', name: 'High ROI', description: 'Achieved >3x ROI on 5+ campaigns', icon: 'Zap', dateEarned: '2023-05-20', rarity: 'Epic' }
    ],
    points: 12450
  },
  {
    id: '2',
    name: 'Meme King',
    handle: '@memeking_69',
    avatar: 'https://picsum.photos/100/100?random=2',
    categories: [KolCategory.MEME, KolCategory.TRADING],
    tags: ['Pepe', 'Doge', 'Solana', 'Degen'],
    totalFollowers: 450000,
    socialAccounts: [
      { platform: SocialPlatform.TWITTER, handle: '@memeking_69', followers: 420000, url: '#', verified: true },
      { platform: SocialPlatform.TIKTOK, handle: '@memeking', followers: 30000, url: '#', verified: false }
    ],
    engagementScore: 94,
    avgViews: 120000,
    priceRange: { min: 1000, max: 5000, currency: 'USDT' },
    trustScore: 72,
    bio: 'Moon or dust. Calling the next 100x gems on Solana.',
    languages: ['English'],
    recentCampaigns: [
      { project: 'FrogCoin', roi: 0.8 },
      { project: 'Doge2.0', roi: 12.5 }
    ],
    reviews: [],
    aiData: {
      overallScore: 78,
      authenticity: 80,
      sentiment: 95,
      commercialValue: 85,
      brandSafety: 60,
      consistency: 90,
      summary: 'High viral potential but higher risk. Good for awareness campaigns.',
      strengths: ['Virality', 'Massive Reach', 'High Engagement'],
      weaknesses: ['Brand Safety Risk', 'Volatile ROI']
    },
    packages: [
      { id: 'p3', title: 'Shill Tweet', description: 'One hype tweet with meme image.', platform: SocialPlatform.TWITTER, price: 1200, deliveryDays: 1, features: ['Meme Creation', 'Tagging'] }
    ],
    sbtBadges: [
        { id: 'b3', name: 'Viral Hit', description: 'Post exceeded 1M views', icon: 'Globe', dateEarned: '2023-08-10', rarity: 'Legendary' }
    ],
    points: 5600
  },
  {
    id: '3',
    name: 'NFT Hunter',
    handle: '@nfthunter',
    avatar: 'https://picsum.photos/100/100?random=3',
    categories: [KolCategory.NFT, KolCategory.GAMEFI],
    tags: ['BlueChip', 'Gaming', 'Art'],
    totalFollowers: 85000,
    socialAccounts: [
      { platform: SocialPlatform.TWITTER, handle: '@nfthunter', followers: 85000, url: '#', verified: true }
    ],
    engagementScore: 82,
    avgViews: 25000,
    priceRange: { min: 400, max: 1200, currency: 'USDT' },
    trustScore: 88,
    bio: 'Collector of fine jpegs. Bullish on gaming.',
    languages: ['English', 'French'],
    recentCampaigns: [
      { project: 'PixelWorlds', roi: 2.8 }
    ],
    reviews: [],
    aiData: {
      overallScore: 85,
      authenticity: 88,
      sentiment: 85,
      commercialValue: 82,
      brandSafety: 90,
      consistency: 80,
      summary: 'Solid choice for NFT mints and game launches.',
      strengths: ['Targeted Audience', 'Consistent'],
      weaknesses: ['Limited Reach']
    },
    packages: [
       { id: 'p4', title: 'Mint Alert', description: 'Announcement of your upcoming mint.', platform: SocialPlatform.TWITTER, price: 500, deliveryDays: 2, features: ['Allowlist Giveaway'] }
    ],
    points: 8200
  }
];

export const MOCK_ORDERS: Order[] = [
  {
    id: 'ORD-8921',
    kolId: '1',
    kolName: 'Crypto Wizard',
    kolAvatar: 'https://picsum.photos/100/100?random=1',
    projectName: 'SuperNova Protocol',
    amount: 800,
    currency: 'USDT',
    status: OrderStatus.COMPLETED,
    dateCreated: '2023-10-01',
    dueDate: '2023-10-05',
    serviceTitle: 'Deep Dive Thread',
    review: { id: 'r1', reviewerName: 'SuperNova Protocol', rating: 5, comment: 'Great work!', date: '2023-10-06', orderId: 'ORD-8921' }
  },
  {
    id: 'ORD-9942',
    kolId: '2',
    kolName: 'Meme King',
    kolAvatar: 'https://picsum.photos/100/100?random=2',
    projectName: 'SuperNova Protocol',
    amount: 1200,
    currency: 'USDT',
    status: OrderStatus.IN_PROGRESS,
    dateCreated: '2023-10-25',
    dueDate: '2023-10-28',
    serviceTitle: 'Shill Tweet',
    monitoring: {
      currentViews: 45200,
      targetViews: 100000,
      currentLikes: 1200,
      timeElapsedPercent: 40,
      status: 'on_track',
      aiInsight: "Viral velocity is increasing. Expected to hit 110% of target.",
      hourlyData: [
        { hour: '0h', views: 0, target: 0 },
        { hour: '4h', views: 5000, target: 4000 },
        { hour: '8h', views: 15000, target: 12000 },
        { hour: '12h', views: 45200, target: 24000 },
      ]
    },
    paymentType: PaymentType.HYBRID,
    tokenDetails: {
      symbol: 'NOVA',
      amount: 5000,
      vestingTerms: '50% unlock at TGE'
    }
  },
  {
    id: 'ORD-1023',
    kolId: '3',
    kolName: 'NFT Hunter',
    kolAvatar: 'https://picsum.photos/100/100?random=3',
    projectName: 'SuperNova Protocol',
    amount: 500,
    currency: 'USDT',
    status: OrderStatus.SUBMITTED, // Test case for timer
    dateCreated: '2023-10-26',
    dueDate: '2023-10-30',
    serviceTitle: 'Mint Alert',
    submissionTime: new Date(Date.now() - 3600000 * 4).toISOString() // Submitted 4 hours ago
  },
  {
    id: 'ORD-1155',
    kolId: '1',
    kolName: 'Crypto Wizard',
    kolAvatar: 'https://picsum.photos/100/100?random=1',
    projectName: 'DeFi Connect',
    amount: 2500,
    currency: 'USDT',
    status: OrderStatus.DISPUTED,
    dateCreated: '2023-10-20',
    dueDate: '2023-10-24',
    serviceTitle: 'Video Review',
  }
];

export const MOCK_PROJECTS: ProjectProfile[] = [
    {
        id: 'proj_1',
        name: 'SuperNova Protocol',
        logo: 'https://picsum.photos/100/100?random=10',
        industry: KolCategory.DEFI,
        description: 'The next generation yield aggregator on Arbitrum. Offering high APY with low risk strategies.',
        website: 'https://supernova.fi',
        budgetRange: '$5k - $20k',
        tags: ['DeFi', 'Yield', 'Arbitrum'],
        activeCampaigns: 2,
        verified: true,
        applications: [
            { id: 'app_1', kolId: '2', kolName: 'Meme King', kolAvatar: 'https://picsum.photos/100/100?random=2', kolHandle: '@memeking_69', pitch: 'I can get this trending on Solana Twitter.', proposedPrice: 1500, date: '2023-10-26', status: 'PENDING' }
        ],
        escrowed: true,
        paymentType: PaymentType.HYBRID,
        tokenDetails: { symbol: 'NOVA', amount: 100000, vestingTerms: 'Linear 6 months' },
        points: 4500
    },
    {
        id: 'proj_2',
        name: 'Pixel Wars',
        logo: 'https://picsum.photos/100/100?random=11',
        industry: KolCategory.GAMEFI,
        description: 'MMORPG built on ImmutableX. Play to earn, own your assets.',
        website: 'https://pixelwars.gg',
        budgetRange: '$10k - $50k',
        tags: ['GameFi', 'Metaverse', 'NFT'],
        activeCampaigns: 1,
        verified: true,
        points: 2200
    },
    {
        id: 'proj_3',
        name: 'BaseSwap',
        logo: 'https://picsum.photos/100/100?random=12',
        industry: KolCategory.DEFI,
        description: 'Native DEX on Base L2.',
        website: 'https://baseswap.xyz',
        budgetRange: '$2k - $8k',
        tags: ['DEX', 'Base', 'Swap'],
        activeCampaigns: 0,
        verified: false,
        points: 800
    }
];

export const MOCK_NOTIFICATIONS: Notification[] = [
    { id: '1', title: 'Offer Accepted', message: 'Crypto Wizard accepted your offer for $800.', type: 'success', date: '2 mins ago', read: false },
    { id: '2', title: 'New Application', message: 'Meme King applied to your "Launch" campaign.', type: 'info', date: '1 hour ago', read: false },
    { id: '3', title: 'Dispute Update', message: 'New evidence uploaded in Dispute #1155.', type: 'warning', date: '3 hours ago', read: true }
];

export const MOCK_CHATS: ChatConversation[] = [
    {
        id: 'c1',
        partnerId: '1',
        partnerName: 'Crypto Wizard',
        partnerAvatar: 'https://picsum.photos/100/100?random=1',
        partnerRole: UserRole.KOL,
        lastMessage: 'Sure, I can have the draft ready by tomorrow.',
        lastMessageTime: '10:45 AM',
        unreadCount: 0,
        messages: [
            { id: 'm1', senderId: 'me', text: 'Hi! We loved your pitch.', timestamp: '10:30 AM', isMe: true },
            { id: 'm2', senderId: '1', text: 'Thanks! I am excited to work on this.', timestamp: '10:32 AM', isMe: false },
            { id: 'm3', senderId: 'me', text: 'When can you start?', timestamp: '10:40 AM', isMe: true },
            { id: 'm4', senderId: '1', text: 'Sure, I can have the draft ready by tomorrow.', timestamp: '10:45 AM', isMe: false }
        ]
    },
    {
        id: 'c2',
        partnerId: '2',
        partnerName: 'Meme King',
        partnerAvatar: 'https://picsum.photos/100/100?random=2',
        partnerRole: UserRole.KOL,
        lastMessage: 'LFG! 🚀',
        lastMessageTime: 'Yesterday',
        unreadCount: 2,
        messages: [
            { id: 'm1', senderId: 'me', text: 'Can you post at 3PM UTC?', timestamp: 'Yesterday', isMe: true },
            { id: 'm2', senderId: '2', text: 'LFG! 🚀', timestamp: 'Yesterday', isMe: false }
        ]
    }
];

export const MOCK_DISPUTES: Dispute[] = [
    {
        id: 'DSP-1001',
        orderId: 'ORD-1155',
        initiatorName: 'DeFi Connect',
        respondentName: 'Crypto Wizard',
        reason: 'Poor Quality / Did not follow brief',
        description: 'The video produced did not include the key features we agreed upon in the brief, specifically the "Staking 2.0" demo.',
        status: 'OPEN',
        evidence: ['brief_v1.pdf', 'video_link.mp4', 'chat_logs.txt'],
        votesForInitiator: 0,
        votesForRespondent: 0,
        dateCreated: '2023-10-24',
        amountLocked: 2500,
        aiAnalysis: {
            recommendation: 'REFUND',
            confidenceScore: 85,
            reasoning: 'Brief clearly stated "Staking 2.0 demo is mandatory". Video analysis confirms this segment is missing. KOL ignored revision request.'
        },
        chatTranscript: [
             { id: 'm1', senderId: 'proj', text: 'Please ensure Staking 2.0 is covered.', timestamp: '2023-10-20', isMe: true },
             { id: 'm2', senderId: 'kol', text: 'Understood.', timestamp: '2023-10-20', isMe: false },
             { id: 'm3', senderId: 'proj', text: 'The video is missing the staking part.', timestamp: '2023-10-23', isMe: true }
        ]
    },
    {
        id: 'DSP-1002',
        orderId: 'ORD-9999',
        initiatorName: 'NFT Hunter',
        respondentName: 'Pixel Wars',
        reason: 'Non-payment after delivery',
        description: 'I delivered the tweets on time, but the project is claiming engagement is botted and refuses to release funds.',
        status: 'OPEN',
        evidence: ['analytics_screenshot.png', 'tweet_link'],
        votesForInitiator: 0,
        votesForRespondent: 0,
        dateCreated: '2023-10-25',
        amountLocked: 500,
        aiAnalysis: {
            recommendation: 'RELEASE',
            confidenceScore: 92,
            reasoning: 'Traffic analysis shows 98% organic engagement from real users. No evidence of botting found.'
        }
    }
];

export const MOCK_SQUADS: KolSquad[] = [
    {
        id: 'sqd_1',
        name: 'Solana Growth Pack',
        description: 'A team of 3 specialized Solana KOLs covering DeFi, NFTs, and Memes. Perfect for a holistic ecosystem launch.',
        coverImage: 'https://picsum.photos/400/200?random=20',
        leaderId: '1',
        members: [
            { kolId: '1', rate: 800 }, // Leader (Crypto Wizard)
            { kolId: '2', rate: 1000 }, // Meme King
            { kolId: '3', rate: 400 }  // NFT Hunter
        ],
        totalFollowers: 690000,
        totalPrice: 1980, // (800 + 1000 + 400) * 0.9
        discountPercentage: 10,
        tags: ['Solana', 'Launch', 'FullStack'],
        applications: [
             { id: 'app_sq1', kolId: '3', kolName: 'NFT Hunter', kolAvatar: 'https://picsum.photos/100/100?random=3', kolHandle: '@nfthunter', reason: 'I cover the NFT side which is missing.', proposedRate: 400, date: '2023-10-26', status: 'PENDING' }
        ]
    },
    {
        id: 'sqd_2',
        name: 'GameFi Hype Team',
        description: 'High energy streamers and tweeters to blow up your game launch.',
        coverImage: 'https://picsum.photos/400/200?random=21',
        leaderId: '2',
        members: [
            { kolId: '2', rate: 1200 },
            { kolId: '3', rate: 500 }
        ],
        totalFollowers: 535000,
        totalPrice: 1445, // (1200 + 500) * 0.85
        discountPercentage: 15,
        tags: ['Gaming', 'Streamers', 'HighTraffic']
    }
];
